export const authorsMock = [
    { user_id: "1", user_name: "Juan Pérez" },
    { user_id: "2", user_name: "María Gómez" },
    { user_id: "3", user_name: "Carlos Rodríguez" },
    { user_id: "4", user_name: "Ana Martínez" },
    { user_id: "5", user_name: "Luis Hernández" },
    { user_id: "6", user_name: "Laura Sánchez" },
    { user_id: "7", user_name: "José Ramírez" },
    { user_id: "8", user_name: "Sofía Torres" },
    { user_id: "9", user_name: "Diego González" },
    { user_id: "10", user_name: "Valentina Díaz" }
];

export const coursesTableMock = {
    "code": 200,
    "count": 651,
    "data": [
        {
            "id": "8e2c5c99-4266-4689-97ac-929168dc14c7",
            author_id: "1",
            author_name: "Juan Pérez",
            author_avatar: "https://i.pravatar.cc/150?u=1",
            "client_id": "6732365d-5633-4c2f-b904-fbc410564eed",
            "name": "adawda",
            "type": "ONLINE",
            "image_url": "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDJ8fGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3MzQzNzcwMzJ8MA&ixlib=rb-4.0.3&q=80&w=1080",
            "created_at": "2024-12-16T19:27:24.716Z",
            "updated_at": "2025-02-11T21:44:40.687Z",
            "deleted_at": null,
            "status": "CONFIGURED",
            "description": null,
            "is_hidden": false,
            "features": null,
            "settings": {
                "scoring": {
                    "min_progress": "100"
                },
                "createdBy": {
                    "id": "c9d554d1-db5e-4ebc-a37e-dcd1f64fc507",
                    "imageUrl": "https://firebasestorage.googleapis.com/v0/b/lapzo-platform-prod.appspot.com/o/assets%2FavatarEducacion_01-02%201.png?alt=media&token=02cabe0c-778f-4f6c-af64-20aa088deb07",
                    "lastName": "QA",
                    "firstName": "Lapzo"
                }
            },
            "catalog": "proprietary",
            "has_dated_modules": false,
            "has_synchronous_sessions": true,
            "has_groups": true,
            "duration": "1.00",
            "difficulty": "medium",
            "external_id": null,
            "privacy": "PUBLIC",
            "topic_subtopic_ids": [
                {
                    "dataTopic": {
                        "topic_id": "1039e87e-c1d5-442c-a5f3-09b158e070fe",
                        "topic_name": "Gestión y Estrategia Empresarial"
                    },
                    "SubTopicsAsociate": [
                        {
                            "subtopic_id": "96946189-e3f3-474f-9fb6-b8970cff09b1",
                            "subtopic_name": "Productividad"
                        },
                        {
                            "subtopic_id": "92fb6072-6022-4ca3-a1cd-984f08791af9",
                            "subtopic_name": "Servicio al cliente"
                        },
                        {
                            "subtopic_id": "293d57f1-c7fa-49aa-958f-776856d1255d",
                            "subtopic_name": "Administración de proyectos"
                        },
                        {
                            "subtopic_id": "09fd0c57-189a-4ea6-826c-85083e678e0c",
                            "subtopic_name": "Negociación"
                        },
                        {
                            "subtopic_id": "b689b7f5-a55a-4f16-abbe-df91dd3e0bbb",
                            "subtopic_name": "Dirección estratégica"
                        },
                        {
                            "subtopic_id": "fed09f6c-158e-40f0-b694-8a9b5824f200",
                            "subtopic_name": "Recursos humanos"
                        }
                    ]
                }
            ],
            "competencies_levels_id": [
                {
                    "competencyParentId": "1a7f9fea-3bb5-40ba-847f-99fcf837609d",
                    "competencyParentName": "Administración de proyectos",
                    "valuesLevels": [
                        {
                            "idLevel": "989e5e60-d728-4087-8566-f53bb7902940",
                            "nameLevel": "Level 3"
                        }
                    ]
                },
                {
                    "competencyParentId": "35e9f801-a577-4ffe-b3af-32ef93e6fc9f",
                    "competencyParentName": "Administración deportiva",
                    "valuesLevels": [
                        {
                            "idLevel": "49838bfe-e677-46ab-b84d-b129d0710f0a",
                            "nameLevel": "Intermedio"
                        }
                    ]
                },
                {
                    "competencyParentId": "d7849cd2-7202-4c80-a410-4a38d5d9e126",
                    "competencyParentName": "Adaptabilidad",
                    "valuesLevels": [
                        {
                            "idLevel": "e9dac0b2-bfd8-4d12-8b9c-b005ae2c0991",
                            "nameLevel": "Básico"
                        }
                    ]
                }
            ],
            "is_from_library": false,
            "is_enabled_dc3": false,
            "is_enabled_dc3_in_course": false,
            "stage": 5,
            "is_draft": false
        },
        {
            "id": "feb1f758-cbda-4ddf-bbcc-5fea98e2dea6",
            author_id: "1",
            author_name: "Juan Pérez",
            author_avatar: "https://i.pravatar.cc/150?u=1",
            "client_id": "6732365d-5633-4c2f-b904-fbc410564eed",
            "name": "adwda",
            "type": "ONLINE",
            "image_url": "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDJ8fGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3Mjk1MTg0MzJ8MA&ixlib=rb-4.0.3&q=80&w=1080",
            "created_at": "2024-10-23T21:35:12.080Z",
            "updated_at": "2025-01-23T18:52:41.916Z",
            "deleted_at": null,
            "status": "CONFIGURED",
            "description": null,
            "is_hidden": false,
            "features": null,
            "settings": {
                "scoring": {
                    "min_score": 100,
                    "min_progress": "100"
                },
                "messages": {
                    "welcome": "Bienvenidos al curso adwda",
                    "default_message": true
                },
                "createdBy": {
                    "id": "56595fa0-f4ec-4764-b185-8164cffca988",
                    "imageUrl": "https://res.cloudinary.com/lernit/image/upload/v1691380743/Courses/yeh6dbwloqpbeldtak9t.png",
                    "lastName": "Quesada",
                    "firstName": "Nikol"
                },
                "hideLandingPageBanner": true
            },
            "catalog": "proprietary",
            "has_dated_modules": false,
            "has_synchronous_sessions": false,
            "has_groups": false,
            "duration": "1.00",
            "difficulty": "medium",
            "external_id": null,
            "privacy": "PRIVATE",
            "topic_subtopic_ids": [
                {
                    "dataTopic": {
                        "topic_id": "5ef1ec34-79d9-4bd0-b048-8572754ddd28",
                        "topic_name": "Default test"
                    },
                    "SubTopicsAsociate": [
                        {
                            "subtopic_id": "aa8ef019-e45e-4007-a26a-51e76f11e20f",
                            "subtopic_name": "Educación"
                        }
                    ]
                }
            ],
            "competencies_levels_id": [],
            "is_from_library": false,
            "is_enabled_dc3": false,
            "is_enabled_dc3_in_course": false,
            "stage": 5,
            "is_draft": false
        },
        {
            "id": "000b7a6f-7f4d-451a-a5f0-48a557abbe13",
            author_id: null,
            author_name: "Ana Martínez",
            author_avatar: "https://i.pravatar.cc/150?u=4",
            "client_id": "6732365d-5633-4c2f-b904-fbc410564eed",
            "name": "Aprende Astronomía Básica ",
            "type": "ONLINE",
            "image_url": "https://firebasestorage.googleapis.com/v0/b/lernit-v2.appspot.com/o/voldemort%2Fcourses%2Fimages%2F1698768777994.jpg?alt=media&token=06ea42d7-67ec-4d2d-998d-484c6ba5d591",
            "created_at": "2023-10-31T16:13:35.592Z",
            "updated_at": "2025-02-12T17:48:10.589Z",
            "deleted_at": null,
            "status": "CONFIGURED",
            "description": "<p>En este curso podra aprender Conceptos basico de astronomia para aficionados, Sabras sobre el sistema solar, exoplanetas, galaxias, estrellas en un nivel inicial para que empieces a tener pasion por esta ciencia.</p>",
            "is_hidden": false,
            "features": {
                "skills": [],
                "knowledge": [],
                "attributes": [],
                "requirements": []
            },
            "settings": {
                "video": {
                    "type": "youtube",
                    "channel": "https://www.youtube.com/watch?v=MiIBM1uFSxg&t=217s",
                    "thumbnail": "https://img.youtube.com/vi/MiIBM1uFSxg&t=217s/0.jpg"
                },
                "scoring": {
                    "min_score": 100,
                    "min_progress": 1
                },
                "messages": {
                    "reason": "<p>Cultura general sobre Astronomia podria ayudarte en algun momento de tu vida.</p>",
                    "welcome": "<p>Bienvenidos al curso Aprende Astronom&iacute;a B&aacute;sica</p>",
                    "default_message": true
                },
                "hideLandingPageBanner": true
            },
            "catalog": "proprietary",
            "has_dated_modules": false,
            "has_synchronous_sessions": false,
            "has_groups": false,
            "duration": "1.00",
            "difficulty": "medium",
            "external_id": null,
            "privacy": "HIDDEN",
            "topic_subtopic_ids": [
                {
                    "dataTopic": {
                        "topic_id": "5ef1ec34-79d9-4bd0-b048-8572754ddd28",
                        "topic_name": "Default test"
                    },
                    "SubTopicsAsociate": [
                        {
                            "subtopic_id": "194c85c9-c8a5-48b4-8dcd-6d153ec21f8c",
                            "subtopic_name": "Tecnologías de información"
                        }
                    ]
                }
            ],
            "competencies_levels_id": [
                {
                    "competencyParentId": "d7849cd2-7202-4c80-a410-4a38d5d9e126",
                    "competencyParentName": "Adaptabilidad",
                    "valuesLevels": [
                        {
                            "idLevel": "e9dac0b2-bfd8-4d12-8b9c-b005ae2c0991",
                            "nameLevel": "Básico"
                        }
                    ]
                }
            ],
            "is_from_library": false,
            "is_enabled_dc3": false,
            "is_enabled_dc3_in_course": false,
            "stage": 5,
            "is_draft": false
        },
        {
            "id": "d74c8176-c1a4-407c-9570-5b542b2ebda2",
            author_id: "5",
            author_name: "Luis Hernández",
            author_avatar: "https://i.pravatar.cc/150?u=5",
            "client_id": "6732365d-5633-4c2f-b904-fbc410564eed",
            "name": "Aprendiendo sobre felinos ",
            "type": "ONLINE",
            "image_url": "https://images.unsplash.com/photo-1602491453631-e2a5ad90a131?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDN8fGFuaW1hbHxlbnwwfHx8fDE2OTg3NjQ4MjB8MA&ixlib=rb-4.0.3&q=80&w=1080",
            "created_at": "2023-10-31T15:07:05.552Z",
            "updated_at": "2025-02-18T13:57:43.617Z",
            "deleted_at": null,
            "status": "CONFIGURED",
            "description": "",
            "is_hidden": false,
            "features": {
                "skills": [],
                "knowledge": [],
                "attributes": [],
                "requirements": []
            },
            "settings": {
                "messages": {
                    "reason": ""
                },
                "hideLandingPageBanner": true
            },
            "catalog": "proprietary",
            "has_dated_modules": false,
            "has_synchronous_sessions": false,
            "has_groups": false,
            "duration": "1.00",
            "difficulty": "medium",
            "external_id": null,
            "privacy": "PRIVATE",
            "topic_subtopic_ids": [
                {
                    "dataTopic": {
                        "topic_id": "5ef1ec34-79d9-4bd0-b048-8572754ddd28",
                        "topic_name": "Default test"
                    },
                    "SubTopicsAsociate": [
                        {
                            "subtopic_id": "aa8ef019-e45e-4007-a26a-51e76f11e20f",
                            "subtopic_name": "Educación"
                        },
                        {
                            "subtopic_id": "194c85c9-c8a5-48b4-8dcd-6d153ec21f8c",
                            "subtopic_name": "Tecnologías de información"
                        },
                        {
                            "subtopic_id": "56c67eac-b0a3-4310-ac33-b4b380efda8a",
                            "subtopic_name": "Gastronomía"
                        },
                        {
                            "subtopic_id": "610943a3-40a3-45b1-83a8-fa378ade9bb2",
                            "subtopic_name": "Negocios"
                        },
                        {
                            "subtopic_id": "8dcb82e7-52cb-4d32-b5b4-8cde5cf08a49",
                            "subtopic_name": "Subtema"
                        },
                        {
                            "subtopic_id": "1f9ede30-b16f-47d4-846d-1164c21b633a",
                            "subtopic_name": "Tema A"
                        },
                        {
                            "subtopic_id": "d2bd83db-75a8-4043-b953-cdba65e4d126",
                            "subtopic_name": "tema B"
                        },
                        {
                            "subtopic_id": "694ba0fe-af29-4983-9d07-a9fcb55e0cc1",
                            "subtopic_name": "tema C"
                        }
                    ]
                }
            ],
            "competencies_levels_id": [
                {
                    "competencyParentId": "0dbf5e8c-bb26-4326-8663-76a86b133519",
                    "competencyParentName": "Agilidad",
                    "valuesLevels": [
                        {
                            "idLevel": "4496fbf9-70d1-4e3d-ae8b-b2455fa2168f",
                            "nameLevel": "Intermedio"
                        }
                    ]
                },
                {
                    "competencyParentId": "d7849cd2-7202-4c80-a410-4a38d5d9e126",
                    "competencyParentName": "Adaptabilidad",
                    "valuesLevels": [
                        {
                            "idLevel": "4496fbf9-70d1-4e3d-ae8b-b2455fa2168f",
                            "nameLevel": "Intermedio"
                        }
                    ]
                }
            ],
            "is_from_library": false,
            "is_enabled_dc3": false,
            "is_enabled_dc3_in_course": false,
            "stage": 5,
            "is_draft": false
        },
        {
            "id": "3b9ac174-bdbc-40e1-9a25-681e41e3d8eb",
            author_id: "2",
            author_name: "María Gómez",
            author_avatar: "https://i.pravatar.cc/150?u=2",
            "client_id": "6732365d-5633-4c2f-b904-fbc410564eed",
            "name": "Autogestión de liderazgo efectivo",
            "type": "ONLINE",
            "image_url": "https://res.cloudinary.com/lernit/image/upload/v1665591418/Courses/luvb8ufe3y9hmmbpazca.png",
            "created_at": "2022-10-12T16:17:00.604Z",
            "updated_at": "2025-01-31T18:57:54.681Z",
            "deleted_at": null,
            "status": "CONFIGURED",
            "description": "Con este curso podrás conocer  la importancia de tener un liderazgo efectivo dentro de tu equipo de trabajo para agregar un valor productivo y producir resultados favorables.\n",
            "is_hidden": false,
            "features": {
                "skills": [
                    "Autogestión",
                    "Autodisciplina"
                ],
                "knowledge": [
                    "Liderazgo efectivo",
                    "Autogestión",
                    "Equipos de alto desempeño",
                    "Motivación"
                ],
                "attributes": null,
                "requirements": [
                    "Internet",
                    "Computadora",
                    "Navegador"
                ]
            },
            "settings": {
                "video": "{}",
                "config": {
                    "min_attendance": 0
                },
                "pricing": {
                    "price": 0,
                    "currency": "USD"
                },
                "scoring": {
                    "min_score": 70,
                    "min_progress": 100
                },
                "messages": {
                    "reason": "Al inscribirte en este curso conocerás la importancia que tiene ser un  buen líder y el impacto que genera  dentro del equipo de trabajo.\n",
                    "wellcome": "Bienvenido(a) al curso de liderazgo y autogestión. Con este curso  podrás conocer la importancia de tener un liderazgo efectivo dentro de tu equipo de trabajo para agregar un valor productivo y producir resultados favorables.\n"
                }
            },
            "catalog": "proprietary",
            "has_dated_modules": false,
            "has_synchronous_sessions": false,
            "has_groups": false,
            "duration": "1.00",
            "difficulty": "medium",
            "external_id": null,
            "privacy": "PRIVATE",
            "topic_subtopic_ids": [
                {
                    "dataTopic": {
                        "topic_id": "5ef1ec34-79d9-4bd0-b048-8572754ddd28",
                        "topic_name": "Default test"
                    },
                    "SubTopicsAsociate": [
                        {
                            "subtopic_id": "aa8ef019-e45e-4007-a26a-51e76f11e20f",
                            "subtopic_name": "Educación"
                        },
                        {
                            "subtopic_id": "194c85c9-c8a5-48b4-8dcd-6d153ec21f8c",
                            "subtopic_name": "Tecnologías de información"
                        },
                        {
                            "subtopic_id": "56c67eac-b0a3-4310-ac33-b4b380efda8a",
                            "subtopic_name": "Gastronomía"
                        },
                        {
                            "subtopic_id": "610943a3-40a3-45b1-83a8-fa378ade9bb2",
                            "subtopic_name": "Negocios"
                        },
                        {
                            "subtopic_id": "8dcb82e7-52cb-4d32-b5b4-8cde5cf08a49",
                            "subtopic_name": "Subtema"
                        },
                        {
                            "subtopic_id": "1f9ede30-b16f-47d4-846d-1164c21b633a",
                            "subtopic_name": "Tema A"
                        },
                        {
                            "subtopic_id": "d2bd83db-75a8-4043-b953-cdba65e4d126",
                            "subtopic_name": "tema B"
                        },
                        {
                            "subtopic_id": "694ba0fe-af29-4983-9d07-a9fcb55e0cc1",
                            "subtopic_name": "tema C"
                        }
                    ]
                }
            ],
            "competencies_levels_id": [
                {
                    "competencyParentId": "23195c30-b584-49e2-bfb5-96cd2951e0b7",
                    "competencyParentName": "Administración",
                    "valuesLevels": [
                        {
                            "idLevel": "781edca4-757e-4749-b63e-a9b1d5c9053a",
                            "nameLevel": "Experto"
                        }
                    ]
                },
                {
                    "competencyParentId": "d3d72df5-a464-437e-ab6a-e95eba4b4b0c",
                    "competencyParentName": "Adaptabilidad",
                    "valuesLevels": [
                        {
                            "idLevel": "e237a6df-93e4-4c45-8fa2-60782c73d682",
                            "nameLevel": "Avanzado"
                        }
                    ]
                },
                {
                    "competencyParentId": "d7849cd2-7202-4c80-a410-4a38d5d9e126",
                    "competencyParentName": "Adaptabilidad",
                    "valuesLevels": [
                        {
                            "idLevel": "e9dac0b2-bfd8-4d12-8b9c-b005ae2c0991",
                            "nameLevel": "Básico"
                        }
                    ]
                }
            ],
            "is_from_library": false,
            "is_enabled_dc3": false,
            "is_enabled_dc3_in_course": false,
            "stage": 8,
            "is_draft": false
        },
        {
            "id": "5d105e25-2eab-423f-8bad-a3e185e7a413",
            "client_id": "6732365d-5633-4c2f-b904-fbc410564eed",
            "name": "Auto Save #06",
            "type": "ONLINE",
            "image_url": "https://images.unsplash.com/photo-1452717602770-b78d1b2115e1?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDI3fHxhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzI4MzE5MDU4fDA&ixlib=rb-4.0.3&q=80&w=1080",
            "created_at": "2024-10-21T20:12:53.638Z",
            "updated_at": "2024-10-28T14:48:29.166Z",
            "deleted_at": null,
            "status": "CONFIGURED",
            "description": null,
            "is_hidden": false,
            "features": null,
            "settings": {
                "scoring": {
                    "min_progress": "100"
                },
                "messages": {
                    "welcome": "<p>Bienvenidos al curso Auto Save #06</p>",
                    "default_message": true
                },
                "createdBy": {
                    "id": "09a0b3d2-ddb1-44be-a2b5-f814f7fe5e6a",
                    "imageUrl": "https://res.cloudinary.com/lernit/image/upload/v1661536009/Courses/isoj5wsgliqxrb3ap9rj.jpg",
                    "lastName": "Rocchia",
                    "firstName": "Franco"
                },
                "hideLandingPageBanner": true
            },
            "catalog": "proprietary",
            "has_dated_modules": false,
            "has_synchronous_sessions": false,
            "has_groups": false,
            "duration": "1.00",
            "difficulty": "medium",
            "external_id": null,
            "privacy": "HIDDEN",
            "topic_subtopic_ids": [
                {
                    "dataTopic": {
                        "topic_id": "5ef1ec34-79d9-4bd0-b048-8572754ddd28",
                        "topic_name": "Default test"
                    },
                    "SubTopicsAsociate": [
                        {
                            "subtopic_id": "aa8ef019-e45e-4007-a26a-51e76f11e20f",
                            "subtopic_name": "Educación"
                        },
                        {
                            "subtopic_id": "194c85c9-c8a5-48b4-8dcd-6d153ec21f8c",
                            "subtopic_name": "Tecnologías de información"
                        },
                        {
                            "subtopic_id": "56c67eac-b0a3-4310-ac33-b4b380efda8a",
                            "subtopic_name": "Gastronomía"
                        },
                        {
                            "subtopic_id": "610943a3-40a3-45b1-83a8-fa378ade9bb2",
                            "subtopic_name": "Negocios"
                        },
                        {
                            "subtopic_id": "8dcb82e7-52cb-4d32-b5b4-8cde5cf08a49",
                            "subtopic_name": "Subtema"
                        },
                        {
                            "subtopic_id": "1f9ede30-b16f-47d4-846d-1164c21b633a",
                            "subtopic_name": "Tema A"
                        },
                        {
                            "subtopic_id": "d2bd83db-75a8-4043-b953-cdba65e4d126",
                            "subtopic_name": "tema B"
                        },
                        {
                            "subtopic_id": "694ba0fe-af29-4983-9d07-a9fcb55e0cc1",
                            "subtopic_name": "tema C"
                        }
                    ]
                }
            ],
            "competencies_levels_id": [],
            "is_from_library": false,
            "is_enabled_dc3": false,
            "is_enabled_dc3_in_course": false,
            "stage": 5,
            "is_draft": false
        },
        {
            "id": "276b68fb-3959-44f7-9295-4876dbff3cec",
            author_id: "9",
            author_name: "Diego González",
            author_avatar: "https://i.pravatar.cc/150?u=9",
            "client_id": "6732365d-5633-4c2f-b904-fbc410564eed",
            "name": "Auto Save #06 - Copia",
            "type": "ONLINE",
            "image_url": "https://images.unsplash.com/photo-1452717602770-b78d1b2115e1?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDI3fHxhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzI4MzE5MDU4fDA&ixlib=rb-4.0.3&q=80&w=1080",
            "created_at": "2024-10-07T17:31:02.031Z",
            "updated_at": "2025-02-18T22:12:03.459Z",
            "deleted_at": null,
            "status": "CONFIGURED",
            "description": null,
            "is_hidden": false,
            "features": null,
            "settings": {
                "scoring": {
                    "min_progress": "100"
                },
                "messages": {
                    "welcome": "Bienvenidos al curso Auto Save #06",
                    "default_message": true
                },
                "createdBy": {
                    "id": "09a0b3d2-ddb1-44be-a2b5-f814f7fe5e6a",
                    "imageUrl": "https://res.cloudinary.com/lernit/image/upload/v1661536009/Courses/isoj5wsgliqxrb3ap9rj.jpg",
                    "lastName": "Rocchia",
                    "firstName": "Franco"
                },
                "hideLandingPageBanner": true
            },
            "catalog": "proprietary",
            "has_dated_modules": false,
            "has_synchronous_sessions": false,
            "has_groups": false,
            "duration": "1.00",
            "difficulty": "medium",
            "external_id": null,
            "privacy": "PUBLIC",
            "topic_subtopic_ids": [
                {
                    "dataTopic": {
                        "topic_id": "5ef1ec34-79d9-4bd0-b048-8572754ddd28",
                        "topic_name": "Default test"
                    },
                    "SubTopicsAsociate": [
                        {
                            "subtopic_id": "aa8ef019-e45e-4007-a26a-51e76f11e20f",
                            "subtopic_name": "Educación"
                        },
                        {
                            "subtopic_id": "194c85c9-c8a5-48b4-8dcd-6d153ec21f8c",
                            "subtopic_name": "Tecnologías de información"
                        },
                        {
                            "subtopic_id": "56c67eac-b0a3-4310-ac33-b4b380efda8a",
                            "subtopic_name": "Gastronomía"
                        },
                        {
                            "subtopic_id": "610943a3-40a3-45b1-83a8-fa378ade9bb2",
                            "subtopic_name": "Negocios"
                        },
                        {
                            "subtopic_id": "8dcb82e7-52cb-4d32-b5b4-8cde5cf08a49",
                            "subtopic_name": "Subtema"
                        },
                        {
                            "subtopic_id": "1f9ede30-b16f-47d4-846d-1164c21b633a",
                            "subtopic_name": "Tema A"
                        },
                        {
                            "subtopic_id": "d2bd83db-75a8-4043-b953-cdba65e4d126",
                            "subtopic_name": "tema B"
                        },
                        {
                            "subtopic_id": "694ba0fe-af29-4983-9d07-a9fcb55e0cc1",
                            "subtopic_name": "tema C"
                        }
                    ]
                }
            ],
            "competencies_levels_id": [],
            "is_from_library": false,
            "is_enabled_dc3": false,
            "is_enabled_dc3_in_course": false,
            "stage": 5,
            "is_draft": false
        },
        {
            "id": "3dcfb578-6769-4544-83bc-ad0731e91a66",
            author_id: "10",
            // author_name: "Valentina Díaz",
            // author_avatar: "https://i.pravatar.cc/150?u=10",
            "client_id": "6732365d-5633-4c2f-b904-fbc410564eed",
            "name": "awdawd",
            "type": "REGISTRO",
            "image_url": "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDJ8fGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3MzY4NTgyNjh8MA&ixlib=rb-4.0.3&q=80&w=1080",
            "created_at": "2025-01-15T19:55:58.394Z",
            "updated_at": "2025-01-15T19:56:44.604Z",
            "deleted_at": null,
            "status": "IN_PROGRESS",
            "description": "adwd",
            "is_hidden": false,
            "features": {
                "skills": [],
                "knowledge": [],
                "attributes": [],
                "requirements": []
            },
            "settings": {
                "video": {
                    "json": {},
                    "enabled": false
                },
                "config": {
                    "dark": "",
                    "stage": 0,
                    "min_attendance": 1
                },
                "pricing": {
                    "price": 0,
                    "currency": "USD"
                },
                "scoring": {
                    "min_score": 80,
                    "min_progress": 100
                },
                "messages": {
                    "reason": "",
                    "welcome": ""
                }
            },
            "catalog": "proprietary",
            "has_dated_modules": false,
            "has_synchronous_sessions": false,
            "has_groups": true,
            "duration": "0.00",
            "difficulty": "easy",
            "external_id": null,
            "privacy": "HIDDEN",
            "topic_subtopic_ids": [
                {
                    "dataTopic": {
                        "topic_id": "1039e87e-c1d5-442c-a5f3-09b158e070fe",
                        "topic_name": "Gestión y Estrategia Empresarial"
                    },
                    "SubTopicsAsociate": [
                        {
                            "subtopic_id": "96946189-e3f3-474f-9fb6-b8970cff09b1",
                            "subtopic_name": "Productividad"
                        },
                        {
                            "subtopic_id": "92fb6072-6022-4ca3-a1cd-984f08791af9",
                            "subtopic_name": "Servicio al cliente"
                        },
                        {
                            "subtopic_id": "293d57f1-c7fa-49aa-958f-776856d1255d",
                            "subtopic_name": "Administración de proyectos"
                        },
                        {
                            "subtopic_id": "09fd0c57-189a-4ea6-826c-85083e678e0c",
                            "subtopic_name": "Negociación"
                        },
                        {
                            "subtopic_id": "b689b7f5-a55a-4f16-abbe-df91dd3e0bbb",
                            "subtopic_name": "Dirección estratégica"
                        },
                        {
                            "subtopic_id": "fed09f6c-158e-40f0-b694-8a9b5824f200",
                            "subtopic_name": "Recursos humanos"
                        }
                    ]
                }
            ],
            "competencies_levels_id": [
                {
                    "competencyParentId": "5889d27d-91f8-41a6-92e5-355f9cb30b62",
                    "competencyParentName": "5 S´s",
                    "valuesLevels": [
                        {
                            "idLevel": "ae2ac9c4-c5d1-4a52-b3cf-14f190d68ac0",
                            "nameLevel": "Level 1"
                        }
                    ]
                }
            ],
            "is_from_library": false,
            "is_enabled_dc3": false,
            "is_enabled_dc3_in_course": false,
            "stage": 5,
            "is_draft": false
        },
        {
            "id": "7f0fc143-dd53-4ca5-94a1-71be1286f6e8",
            author_id: "10",
            author_name: "Valentina Díaz",
            author_avatar: "https://i.pravatar.cc/150?u=10",
            "client_id": "6732365d-5633-4c2f-b904-fbc410564eed",
            "name": "Banco de Preguntas #03",
            "type": "ONLINE",
            "image_url": "https://images.unsplash.com/photo-1527769929977-c341ee9f2033?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w1MDI5MnwwfDF8c2VhcmNofDEzfHx3YWxscGFwZXJ8ZW58MHx8fHwxNzI4MzExOTM5fDA&ixlib=rb-4.0.3&q=80&w=1080",
            "created_at": "2024-10-09T16:06:55.223Z",
            "updated_at": "2025-02-20T19:18:19.760Z",
            "deleted_at": null,
            "status": "CONFIGURED",
            "description": null,
            "is_hidden": false,
            "features": null,
            "settings": {
                "scoring": {
                    "min_progress": "100"
                },
                "messages": {
                    "welcome": "<p>Bienvenidos al curso Banco de Preguntas #03</p>",
                    "default_message": true
                },
                "createdBy": {
                    "id": "09a0b3d2-ddb1-44be-a2b5-f814f7fe5e6a",
                    "imageUrl": "https://res.cloudinary.com/lernit/image/upload/v1661536009/Courses/isoj5wsgliqxrb3ap9rj.jpg",
                    "lastName": "Rocchia",
                    "firstName": "Franco"
                },
                "hideLandingPageBanner": true
            },
            "catalog": "proprietary",
            "has_dated_modules": false,
            "has_synchronous_sessions": false,
            "has_groups": false,
            "duration": "1.00",
            "difficulty": "medium",
            "external_id": null,
            "privacy": "PRIVATE",
            "topic_subtopic_ids": [
                {
                    "dataTopic": {
                        "topic_id": "1039e87e-c1d5-442c-a5f3-09b158e070fe",
                        "topic_name": "Gestión y Estrategia Empresarial"
                    },
                    "SubTopicsAsociate": [
                        {
                            "subtopic_id": "96946189-e3f3-474f-9fb6-b8970cff09b1",
                            "subtopic_name": "Productividad"
                        },
                        {
                            "subtopic_id": "92fb6072-6022-4ca3-a1cd-984f08791af9",
                            "subtopic_name": "Servicio al cliente"
                        },
                        {
                            "subtopic_id": "293d57f1-c7fa-49aa-958f-776856d1255d",
                            "subtopic_name": "Administración de proyectos"
                        },
                        {
                            "subtopic_id": "09fd0c57-189a-4ea6-826c-85083e678e0c",
                            "subtopic_name": "Negociación"
                        },
                        {
                            "subtopic_id": "b689b7f5-a55a-4f16-abbe-df91dd3e0bbb",
                            "subtopic_name": "Dirección estratégica"
                        },
                        {
                            "subtopic_id": "fed09f6c-158e-40f0-b694-8a9b5824f200",
                            "subtopic_name": "Recursos humanos"
                        }
                    ]
                },
                {
                    "dataTopic": {
                        "topic_id": "5ef1ec34-79d9-4bd0-b048-8572754ddd28",
                        "topic_name": "Default test"
                    },
                    "SubTopicsAsociate": [
                        {
                            "subtopic_id": "aa8ef019-e45e-4007-a26a-51e76f11e20f",
                            "subtopic_name": "Educación"
                        },
                        {
                            "subtopic_id": "194c85c9-c8a5-48b4-8dcd-6d153ec21f8c",
                            "subtopic_name": "Tecnologías de información"
                        },
                        {
                            "subtopic_id": "56c67eac-b0a3-4310-ac33-b4b380efda8a",
                            "subtopic_name": "Gastronomía"
                        },
                        {
                            "subtopic_id": "610943a3-40a3-45b1-83a8-fa378ade9bb2",
                            "subtopic_name": "Negocios"
                        },
                        {
                            "subtopic_id": "8dcb82e7-52cb-4d32-b5b4-8cde5cf08a49",
                            "subtopic_name": "Subtema"
                        },
                        {
                            "subtopic_id": "1f9ede30-b16f-47d4-846d-1164c21b633a",
                            "subtopic_name": "Tema A"
                        },
                        {
                            "subtopic_id": "d2bd83db-75a8-4043-b953-cdba65e4d126",
                            "subtopic_name": "tema B"
                        },
                        {
                            "subtopic_id": "694ba0fe-af29-4983-9d07-a9fcb55e0cc1",
                            "subtopic_name": "tema C"
                        }
                    ]
                }
            ],
            "competencies_levels_id": [
                {
                    "competencyParentId": "d7849cd2-7202-4c80-a410-4a38d5d9e126",
                    "competencyParentName": "Adaptabilidad",
                    "valuesLevels": [
                        {
                            "idLevel": "e9dac0b2-bfd8-4d12-8b9c-b005ae2c0991",
                            "nameLevel": "Básico"
                        }
                    ]
                }
            ],
            "is_from_library": false,
            "is_enabled_dc3": false,
            "is_enabled_dc3_in_course": false,
            "stage": 5,
            "is_draft": false
        },
        {
            "id": "026c4287-1027-48e6-b473-227b3d5ed37b",
            author_id: "8",
            author_name: "Sofía Torres",
            author_avatar: "https://i.pravatar.cc/150?u=8",
            "client_id": "6732365d-5633-4c2f-b904-fbc410564eed",
            "name": "¡Bienvenido a Lapzo!",
            "type": "ONLINE",
            "image_url": "https://res.cloudinary.com/lernit/image/upload/v1616775343/Courses/vday07jey5h1ll661xfy.jpg",
            "created_at": "2021-01-20T03:03:18.737Z",
            "updated_at": "2024-10-28T17:31:54.860Z",
            "deleted_at": null,
            "status": "CONFIGURED",
            "description": "<p>&iexcl;Bienvenido a Lernit!\nEstamos emocionados en que formes parte de este equipo.</p>",
            "is_hidden": false,
            "features": {
                "skills": [
                    "Predisposición a aprender"
                ],
                "knowledge": [
                    "Historia de Lernit",
                    "Quiénes conforman el equipo de líderes dentro de Lernit",
                    "Valores institucionales ",
                    "Elementos para ser exitoso"
                ],
                "attributes": null,
                "requirements": [
                    "Ninguno"
                ]
            },
            "settings": {
                "video": "{}",
                "config": {
                    "min_attendance": 0
                },
                "pricing": {
                    "price": 0,
                    "currency": "USD"
                },
                "scoring": {
                    "min_score": 0,
                    "min_progress": 100
                },
                "messages": {
                    "reason": "<p>El objetivo de este curso, principalmente, es que conozcas sobre la historia de Lernit, los valores y aptitudes que nos distinguen como equipo.</p>",
                    "wellcome": ""
                }
            },
            "catalog": "proprietary",
            "has_dated_modules": false,
            "has_synchronous_sessions": false,
            "has_groups": false,
            "duration": "1.00",
            "difficulty": "medium",
            "external_id": null,
            "privacy": "PUBLIC",
            "topic_subtopic_ids": [
                {
                    "dataTopic": {
                        "topic_id": "5ef1ec34-79d9-4bd0-b048-8572754ddd28",
                        "topic_name": "Default test"
                    },
                    "SubTopicsAsociate": [
                        {
                            "subtopic_id": "aa8ef019-e45e-4007-a26a-51e76f11e20f",
                            "subtopic_name": "Educación"
                        },
                        {
                            "subtopic_id": "194c85c9-c8a5-48b4-8dcd-6d153ec21f8c",
                            "subtopic_name": "Tecnologías de información"
                        },
                        {
                            "subtopic_id": "56c67eac-b0a3-4310-ac33-b4b380efda8a",
                            "subtopic_name": "Gastronomía"
                        },
                        {
                            "subtopic_id": "610943a3-40a3-45b1-83a8-fa378ade9bb2",
                            "subtopic_name": "Negocios"
                        },
                        {
                            "subtopic_id": "8dcb82e7-52cb-4d32-b5b4-8cde5cf08a49",
                            "subtopic_name": "Subtema"
                        },
                        {
                            "subtopic_id": "1f9ede30-b16f-47d4-846d-1164c21b633a",
                            "subtopic_name": "Tema A"
                        },
                        {
                            "subtopic_id": "d2bd83db-75a8-4043-b953-cdba65e4d126",
                            "subtopic_name": "tema B"
                        },
                        {
                            "subtopic_id": "694ba0fe-af29-4983-9d07-a9fcb55e0cc1",
                            "subtopic_name": "tema C"
                        }
                    ]
                }
            ],
            "competencies_levels_id": [],
            "is_from_library": false,
            "is_enabled_dc3": false,
            "is_enabled_dc3_in_course": false,
            "stage": 5,
            "is_draft": false
        }
    ],
}